import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';
import {
    IEmailSubscription,
    IUpdatePasswordPayload,
    IUserInfo,
} from 'types/user';
import { applyTokenToUrl } from 'utils/helpers';

export const getUserInfo = async (): Promise<IBodyResponse<IUserInfo>> => {
    const response = await axiosInstance.get('admin/admins/me');
    return response.data;
};

export const updateUserInfo = async (
    data: FormData
): Promise<IBodyResponse<IUserInfo>> => {
    const response = await axiosInstance.put(
        'admin/admins/update_profile',
        data,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );
    return response.data;
};

export const updatePassword = async (
    data: IUpdatePasswordPayload
): Promise<IBodyResponse<null>> => {
    const response = await axiosInstance.put(
        'admin/admins/update_password',
        data
    );
    return response.data;
};

export const getStatusEmailSubscription = async (): Promise<
    IBodyResponse<IEmailSubscription>
> => {
    const response = await axiosInstance.get(
        applyTokenToUrl('admin/admins/mail_subscription')
    );
    return response.data;
};

export const emailSubscription = async (): Promise<
    IBodyResponse<IEmailSubscription>
> => {
    const response = await axiosInstance.put(
        applyTokenToUrl('admin/admins/update_mail_subscription')
    );
    return response.data;
};

export const currentPlan = async (): Promise<
    IBodyResponse<any> // eslint-disable-line
> => {
    const response = await axiosInstance.get('admin/admins/current_plan');
    return response.data;
};
